import IModel from "../model/applicationForm/IApplicationForm";
import {Api} from "@/module/api";
import {ICommunicationError} from "@dev/hc-talk-talk";
import IApplication from "../model/IApplication";
import FinancedSubjectType from "@/module/main/dto/FinancedSubjectTypeEnum";
import ApplicationV1Mapper from "./ApplicationV1Mapper";
import ApplicationV2Mapper from "./ApplicationV2Mapper";
import ApplicationV3Mapper from "@/module/main/service/ApplicationV3Mapper";
import OriginationV2Mapper from "@/module/main/service/OriginationV2Mapper";
import ClientType from "@/module/main/dto/ClientTypeEnum";
import CashFinancingType from "@/module/main/dto/CashFinancingTypeEnum";
import OrderType from "@/module/main/dto/OrderTypeEnum";
import FinancingApiVersion from "@/module/main/dto/FinancingApiVersionEnum";
import CarLoanType from "@/module/main/dto/CarLoanTypeEnum";

class Application
{
    public createApplication(application: IModel): Promise<IApplication> {

        let mapper: any;
        switch (application.loan.financedSubjectType)
        {
            case FinancedSubjectType.CASH:
                if (application.loan.clientType === ClientType.PERSON) {
                    mapper = application.loan.cashFinancingType === CashFinancingType.CASH_LOAN
                        ? ApplicationV3Mapper
                        : ApplicationV2Mapper;
                } else {
                    mapper = ApplicationV3Mapper;
                }
                break;
            case FinancedSubjectType.LIABILITY:
                mapper = ApplicationV2Mapper;
                break;
            case FinancedSubjectType.ORDER:
                switch (application.loan.orderType)
                {
                    case OrderType.CAR_LOAN:
                        mapper = application.loan.carLoanType === CarLoanType.LARGE_CARS
                            ? ApplicationV3Mapper
                            : OriginationV2Mapper;
                        break;
                    case OrderType.STANDARD:
                        mapper = application.envSettings.financingApiVersion === FinancingApiVersion.V1
                            && application.loan.clientType === ClientType.PERSON
                            ? ApplicationV1Mapper
                            : ApplicationV3Mapper;
                        break;
                    default:
                        mapper = ApplicationV3Mapper;
                }
                break;
            case FinancedSubjectType.WALLET:
                mapper = ApplicationV3Mapper;
                break;
        }

        return new Promise((resolve, reject) =>
        {
            Api.createApplication(mapper.toCreateRequest(application), application.envSettings.envType, application.envSettings.getEnvValue(),
                mapper.API_NAME, mapper.VERSION)
                .then((response: any) =>
                {
                    resolve(mapper.fromResponse(response));
                })
                .catch((error: ICommunicationError) =>
                {
                    reject(error);
                });
        });
    }
}

export default new Application();
